export const fiveMinutesInSeconds = 300;
export const maxJSDateInMilliseconds = 8_640_000_000_000_000;
export const oneDayInMilliseconds = 86_400_000;
export const oneMinuteInSeconds = 60;
export const oneSecond = 1;
export const popupShowTimeInMiliseconds = 5000;
export const reservationExpiryInMinutes = 20;
